import Vue from "vue";
import Vuex from "vuex";
import { Notification } from "element-ui";
import { getRequest } from "../utils/api";
import "../utils/stomp";
import "../utils/sockjs";

Vue.use(Vuex);

const now = new Date();

const store = new Vuex.Store({
  state: {
    routes: [],
    sessions: {},
    hrs: [],
    currentSession: null,
    currentHr: JSON.parse(window.sessionStorage.getItem("user")),
    filterKey: "",
    stomp: null,
    isDot: {},
  },
  mutations: {
    INIT_CURRENTHR(state, hr) {
      state.currentHr = hr;
    },
    initRoutes(state, data) {
      state.routes = data;
    },
    changeCurrentSession(state, currentSession) {
      Vue.set(
        state.isDot,
        state.currentHr.username + "#" + currentSession.username,
        false
      );
      state.currentSession = currentSession;
    },
    addMessage(state, msg) {
      let mss = state.sessions[state.currentHr.username + "#" + msg.to];
      if (!mss) {
        // state.sessions[state.currentHr.username+'#'+msg.to] = [];
        Vue.set(state.sessions, state.currentHr.username + "#" + msg.to, []);
      }
      state.sessions[state.currentHr.username + "#" + msg.to].push({
        content: msg.content,
        date: new Date(),
        self: !msg.notSelf,
      });
    },
    INIT_HR(state, data) {
      state.hrs = data;
    },
  },
});

export default store;
